import { useLocation, useNavigate, useParams } from '@tanstack/react-router'
import { ComponentType } from 'react'

export function withRouterNavigate(Component: ComponentType<any>) {
    function ComponentWithRouterProp(props: Record<string, unknown>) {
        const navigate = useNavigate()
        const params = useParams({ strict: false })
        const location = useLocation()

        return <Component {...props} navigate={navigate} params={params} location={location} />
    }

    return ComponentWithRouterProp
}
